import { FC } from 'react';
import { Button, Heading, HStack, VStack } from '@chakra-ui/react';
import { External, FacebookLinked, FacebookUnlinked } from '../../../assets';
import { useAchievements, useFundraiser } from '../../../hooks';
import { Card, Loader, Notification } from '../../../components';
import { getDataTracking } from '../../../utils';
import { useFbFundraiser } from '../../../hooks/use-fb-fundraiser';

export const FacebookFundraiser: FC = () => {
  const {
    data: { facebookFundraiserId },
  } = useAchievements();
  const {
    dismissExist,
    handleFbFundraiserDismissInteraction,
    isInitialLoading,
  } = useFundraiser();
  const { handleFbLogin, status } = useFbFundraiser();

  const facebookFundraiser = Boolean(facebookFundraiserId) || false;
  const FacebookDismissHandler = () => {
    handleFbFundraiserDismissInteraction();
  };

  // if the fundraiser notification dismissed once it shouldn't show
  if (isInitialLoading) return <Loader />;
  if (dismissExist) return null;

  const fbFundraiserUrl = `https://www.facebook.com/donate/${facebookFundraiserId}/`;

  return (
    <>
      <Notification message={status?.message || ''} />
      <Card bg="brand.secondary.swatch4" px={6}>
        <HStack mb={4} justifyContent="space-between">
          <Heading fontSize="28px" color="white">
            Create a Facebook Fundraiser
          </Heading>
          {!facebookFundraiser ? (
            <FacebookUnlinked boxSize={82} />
          ) : (
            <FacebookLinked />
          )}
        </HStack>
        <HStack mb={4} textColor="white">
          {!facebookFundraiser && (
            <p color="white">
              Connect your Facebook account and start sharing your fundraiser
              with friends and family around the globe.
            </p>
          )}
        </HStack>
        <VStack mb={3}>
          <Button
            w="full"
            colorScheme="white"
            color="brand.secondary.swatch4"
            leftIcon={<External boxSize={11} />}
            {...(!facebookFundraiserId
              ? { onClick: handleFbLogin }
              : { as: 'a', href: fbFundraiserUrl })}
            {...getDataTracking('connectToFbButton')}
          >
            {!facebookFundraiser
              ? 'Connect to Facebook'
              : 'Visit Facebook Fundraiser'}
          </Button>
          {!facebookFundraiser && (
            <Button
              colorScheme="white"
              variant="ghost"
              onClick={FacebookDismissHandler}
              {...getDataTracking('dismissThisMessageButton')}
            >
              Dismiss this message
            </Button>
          )}
        </VStack>
      </Card>
    </>
  );
};
